import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Web-specific hook for handling post-authentication redirect.
 * Manages the "after" URL parameter to redirect users back to their intended destination.
 */
export interface UseLoginRedirectResult {
  afterParam: string | null;
  shouldStartInLoginMode: boolean;
  redirectAfterSuccess: () => void;
}

export function useLoginRedirect(): UseLoginRedirectResult {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const afterParam = searchParams.get('after');

  const redirectAfterSuccess = useCallback(() => {
    navigate(afterParam || '/');
  }, [navigate, afterParam]);

  return {
    afterParam,
    shouldStartInLoginMode: !!afterParam, // If "after" exists, start in login mode
    redirectAfterSuccess,
  };
}
